<template>
  <div>
    <v-layout row wrap pt-2>
      <v-flex xs8 sm6 md9>
        {{attendanceSummary.description}}
      </v-flex>
      <v-flex xs4 v-if="$vuetify.breakpoint.xsOnly" class="text-xs-right">
        <h3>{{attendanceSummary.percentage}}%</h3>
      </v-flex>
      <v-flex xs2 md1 class="hidden-xs-only text-xs-right">
        {{attendanceSummary.expected}}
      </v-flex>
      <v-flex xs2 md1 class="hidden-xs-only text-xs-right">
        {{attendanceSummary.attended}}
      </v-flex>
      <v-flex xs2 md1 class="hidden-xs-only text-xs-right">
        {{attendanceSummary.percentage}}%
      </v-flex>
      <v-flex xs6 class="hidden-sm-and-up">
        {{$t('attendance.summary.expected')}}: <h3 class="d-inline-block">{{attendanceSummary.expected}}</h3>
      </v-flex>
      <v-flex xs6 class="hidden-sm-and-up text-xs-right">
        {{$t('attendance.summary.attended')}}: <h3 class="d-inline-block">{{attendanceSummary.attended}}</h3>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </div>
</template>

<script>
  export default {
    name: 'student-attendance-summary-row',
    props: ['attendanceSummary'],
    mixins: [],
    data () {
      return {}
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/student/StudentAttendanceSummaryRow.vue